__turbopack_context__.v({
  "dark": "Link-module__pXC2gW__dark",
  "extraPadding": "Link-module__pXC2gW__extraPadding",
  "light": "Link-module__pXC2gW__light",
  "linkContainer": "Link-module__pXC2gW__linkContainer",
  "linkLabel": "Link-module__pXC2gW__linkLabel",
  "linkPadding": "Link-module__pXC2gW__linkPadding",
});
